import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import { forwardRef } from "react";
import styled from "styled-components";
import Box from "../box";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScrollAreaThumb = styled(ScrollAreaPrimitive.Thumb).withConfig({
  displayName: "scroll-area__ScrollAreaThumb",
  componentId: "sc-1rr0zik-0"
})(["flex:1;position:relative;background:", ";border-radius:var(--scrollbar-size);&::before{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;min-width:44px;min-height:44px;content:\"\";}"], p => p.theme.colors.alpha[5]);
const ScrollAreaScrollbar = styled(ScrollAreaPrimitive.Scrollbar).withConfig({
  displayName: "scroll-area__ScrollAreaScrollbar",
  componentId: "sc-1rr0zik-1"
})(["display:flex;padding:2px;background:", ";transition:background 160ms ease-out;user-select:none;touch-action:none;&:hover{background:", ";}&[data-orientation=\"vertical\"]{width:var(--scrollbar-size);}&[data-orientation=\"horizontal\"]{flex-direction:column;height:var(--scrollbar-size);}"], p => p.theme.colors.alpha[0], p => p.theme.colors.alpha[3]);
const ScrollAreaCorner = styled(ScrollAreaPrimitive.Corner).withConfig({
  displayName: "scroll-area__ScrollAreaCorner",
  componentId: "sc-1rr0zik-2"
})(["background:", ";"], p => p.theme.colors.alpha[3]);
const ScrollAreaViewport = styled(ScrollAreaPrimitive.Viewport).withConfig({
  displayName: "scroll-area__ScrollAreaViewport",
  componentId: "sc-1rr0zik-3"
})(["width:100%;height:100%;max-height:inherit;border-radius:inherit;& > div{height:inherit;display:block !important;}"]);
const ScrollAreaRoot = styled(ScrollAreaPrimitive.Root).withConfig({
  displayName: "scroll-area__ScrollAreaRoot",
  componentId: "sc-1rr0zik-4"
})(["--scrollbar-size:8px;overflow:hidden;", "{overscroll-behavior:", ";}&[data-variant=\"inverted\"]{", "{background:", ";}", "{background:", ";&:hover{background:", ";}}", "{background:", ";}}"], ScrollAreaViewport, p => p.overScroll, ScrollAreaThumb, p => p.theme.colors.alpha.white[5], ScrollAreaScrollbar, p => p.theme.colors.alpha.white[0], p => p.theme.colors.alpha.white[3], ScrollAreaCorner, p => p.theme.colors.alpha.white[3]);
export const ScrollArea = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    type = "hover",
    scrollHideDelay = 600,
    variant = "default",
    overScroll = "auto",
    color,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(ScrollAreaRoot, {
    asChild: true,
    type: type,
    scrollHideDelay: scrollHideDelay,
    overScroll: overScroll,
    "data-variant": variant,
    children: /*#__PURE__*/_jsxs(Box, {
      ref: ref,
      ...rest,
      color: color,
      children: [/*#__PURE__*/_jsx(ScrollAreaViewport, {
        children: children
      }), /*#__PURE__*/_jsx(ScrollAreaScrollbar, {
        orientation: "vertical",
        children: /*#__PURE__*/_jsx(ScrollAreaThumb, {})
      }), /*#__PURE__*/_jsx(ScrollAreaScrollbar, {
        orientation: "horizontal",
        children: /*#__PURE__*/_jsx(ScrollAreaThumb, {})
      }), /*#__PURE__*/_jsx(ScrollAreaCorner, {})]
    })
  });
});
export default ScrollArea;